// extracted by mini-css-extract-plugin
export default {"bodyMain":"PageMain_bodyMain__D0g2W","centered":"PageMain_centered__n9IJg"};